export default {
  props: { name: "bars" }
}
